import TipsTricksList from './TipsTricksList'

export default TipsTricksList
